module.exports = __webpack_public_path__ + "static/media/icon_model-cubes.8ea04b17.svg";